import { render, staticRenderFns } from "./StockProfitModal.vue?vue&type=template&id=53129a08&scoped=true&"
import script from "./StockProfitModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StockProfitModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./StockProfitModal.vue?vue&type=style&index=0&id=53129a08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53129a08",
  null
  
)

export default component.exports